import React, { FC } from "react";
import { useIntl } from "react-intl";
import {
  CheckCircleOutlined,
  FolderOpenOutlined,
  LoginOutlined,
} from "@ant-design/icons";
import { List } from "antd";

export const TwoFactorInfo: FC = () => {
  const { formatMessage } = useIntl();

  const items: { title: string; subTitle: string; icon: React.ReactNode }[] = [
    {
      title: formatMessage({ id: "home.info.4.option-1.title" }),
      subTitle: formatMessage({ id: "home.info.4.option-1.sub-title" }),
      icon: <LoginOutlined />,
    },
    {
      title: formatMessage({ id: "home.info.4.option-2.title" }),
      subTitle: formatMessage({ id: "home.info.4.option-2.sub-title" }),
      icon: <FolderOpenOutlined />,
    },
    {
      title: formatMessage({ id: "home.info.4.option-3.title" }),
      subTitle: formatMessage({ id: "home.info.4.option-3.sub-title" }),
      icon: <CheckCircleOutlined />,
    },
  ];

  return (
    <div>
      <p>{formatMessage({ id: "home.info.4.text" })}</p>
      <List
        style={{ color: "white" }}
        dataSource={items}
        renderItem={(item) => (
          <List.Item>
            <List.Item.Meta
              avatar={<span style={{ color: "white" }}>{item.icon}</span>}
              title={<span style={{ color: "white" }}>{item.title}</span>}
              description={
                <span style={{ color: "lightgray" }}>{item.subTitle}</span>
              }
            />
          </List.Item>
        )}
      />
    </div>
  );
};
